<div
  class="d-flex justify-content-center align-items-center"
  *ngIf="loadingTemplates; else notificationConfigurationForm">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<ng-template #notificationConfigurationForm>
  <div class="notification-configuration-form">
    <h5 class="fs-6">Notification channels</h5>
    <div class="switches">
      <div class="form-check form-switch me-4">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="emailSwitch"
          [checked]="emailSwitch"
          (change)="toggleEmailSwitch($event)" />
        <label class="form-check-label" for="emailSwitch">Email</label>
      </div>
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="SMSSwitch"
          [checked]="smsSwitch"
          (change)="toggleSmsSwitch($event)" />
        <label class="form-check-label" for="SMSSwitch">SMS</label>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row" *ngIf="emailSwitch || smsSwitch">
      <div class="col-6 border-end border-2">
        <div class="languages">
          <ul
            class="nav nav-pills border border-1 border-primary bg-light-blue rounded-1 p-1">
            <li class="nav-item" *ngFor="let language of languages">
              <a
                class="nav-link"
                [ngClass]="{ active: selectedLanguage?.id === language.id }"
                (click)="onLanguageChange(language)"
                >{{ language.name }}</a
              >
            </li>
          </ul>
        </div>

        <ng-container *ngIf="selectedLanguage">
          <form [formGroup]="languageForms[selectedLanguage.locale]">
            <ng-container>
              <div class="form-group mb-4">
                <label for="notificationType" class="form-label"
                  >Notification Title ({{ selectedLanguage.locale }})</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="title"
                  formControlName="title"
                  placeholder="Enter notification title" />
              </div>

              <nav class="mb-4">
                <ul class="nav nav-tabs nav-justified" role="tablist">
                  <button
                    class="nav-link"
                    type="button"
                    role="tab"
                    [ngClass]="{ active: selectedTab.id === tab.id }"
                    [id]="tab.id"
                    (click)="onTabChange(tab)"
                    *ngFor="let tab of tabButtons">
                    <i [class]="tab.icon"></i>{{ tab.label }}
                  </button>
                </ul>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div
                  class="tab-pane fade"
                  [ngClass]="{
                    active: selectedTab.id === 'email-tab',
                    show: selectedTab.id === 'email-tab'
                  }"
                  role="tabpanel">
                  <div
                    *ngIf="
                      !isEmailTemplateSelected ||
                        (isEmailTemplateSelected && editEmailTemplateSwitch);
                      else editEmailSwicth
                    ">
                    <div class="editors-tabs mb-3">
                      <ul
                        class="nav nav-pills border border-1 border-primary bg-light-blue rounded-1 p-1">
                        <li
                          class="nav-item flex-grow-1 text-center"
                          *ngFor="let tab of editorsTabs">
                          <a
                            class="nav-link"
                            [ngClass]="{
                              active: selectedEditorTab.id === tab.id
                            }"
                            (click)="onEditorTabChange(tab)"
                            >{{ tab.label }}</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="form-group" *ngIf="isTextEditorSelected()">
                      <label for="emailMessage" class="form-label"
                        >Email Body ({{ selectedLanguage.locale }})</label
                      >
                      <quill-editor
                        format="html"
                        [modules]="quillConfig"
                        id="emailMessage"
                        formControlName="emailMessage"
                        [required]="true"></quill-editor>
                    </div>
                    <div class="form-group mb-4" *ngIf="isCodeEditorSelected()">
                      <label for="emailHtmlMessage" class="form-label"
                        >Email HTML Body ({{ selectedLanguage.locale }})</label
                      >
                      <ngx-monaco-editor
                        [options]="htmlEdiorOptions"
                        formControlName="htmlCode"
                        style="height: 500px"></ngx-monaco-editor>
                    </div>
                  </div>
                  <ng-template #editEmailSwicth>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="editSwitch"
                        [checked]="editEmailTemplateSwitch"
                        (change)="toggleEditEmailTemplateSwitch($event)" />
                      <label class="form-check-label" for="editSwitch"
                        >Edit Template</label
                      >
                    </div>
                  </ng-template>
                </div>
                <div
                  class="tab-pane fade"
                  [ngClass]="{
                    active: selectedTab.id === 'sms-tab',
                    show: selectedTab.id === 'sms-tab'
                  }"
                  role="tabpanel">
                  <div
                    *ngIf="
                      !isSmsTemplateSelected ||
                        (isSmsTemplateSelected && editSMSTemplateSwitch);
                      else editSmsSwitch
                    ">
                    <label for="smsBody" class="form-label"
                      >SMS Body ({{ selectedLanguage.locale }})</label
                    >
                    <quill-editor
                      format="text"
                      [modules]="quillConfig"
                      id="smsBody"
                      formControlName="smsBody"
                      [required]="true"></quill-editor>
                  </div>
                  <ng-template #editSmsSwitch>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="editSMSSwitch"
                        [checked]="editSMSTemplateSwitch"
                        (change)="toggleEditSMSTemplateSwitch($event)" />
                      <label class="form-check-label" for="editSMSSwitch"
                        >Edit Template</label
                      >
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </form>
          <div class="d-flex justify-content-end gap-2 mt-4">
            <button
              type="button"
              class="btn btn-outline-dark"
              (click)="onCancel()">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="onSubmit()"
              [disabled]="!isFormValid()">
              Save
            </button>
          </div>
        </ng-container>
      </div>
      <div class="col-6" *ngIf="selectedLanguage">
        <h5 class="mb-4 form-title text-center">
          {{ isEmailTabSelected() ? 'Email' : 'Phone' }} Preview
        </h5>
        <irembogov-notification-configuration-preview
          [template]="selectedTemplate$.getValue() || null"
          [locale]="selectedLanguage.locale"
          [data]="notificationPeviewData"
          [isEmail]="
            isEmailTabSelected()
          "></irembogov-notification-configuration-preview>
      </div>
    </div>
  </div>
</ng-template>
